"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Requests AND stores flag configurations
class FlagConfigurationRequestor {
    constructor(configurationStore, httpClient) {
        this.configurationStore = configurationStore;
        this.httpClient = httpClient;
    }
    async fetchAndStoreConfigurations() {
        const responseData = await this.httpClient.getUniversalFlagConfiguration();
        if (!responseData) {
            return {};
        }
        await this.configurationStore.setEntries(responseData.flags);
        return responseData.flags;
    }
}
exports.default = FlagConfigurationRequestor;
//# sourceMappingURL=flag-configuration-requestor.js.map